// ===== HIDE UNAVAILABLE VARIANTS =====
function hideUnavailableVariants() {
  const cards = document.querySelectorAll('.card-wrapper, .card');

  cards.forEach(card => {
    const productLink = card.querySelector('a[href*="/products/"]');
    if (!productLink) return;

    const productUrl = productLink.getAttribute('href').split('?')[0];
    const variantPills = card.querySelectorAll('.variant-pill');

    if (variantPills.length === 0) return;
    if (card.dataset.variantsChecked === 'true') return;

    card.dataset.variantsChecked = 'true';

    const xhr = new XMLHttpRequest();
    xhr.open('GET', productUrl + '.js', true);
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        const product = JSON.parse(xhr.responseText);
        variantPills.forEach(pill => {
          const variant = product.variants.find(v => v.id == pill.dataset.variantId);
          if (!variant || !variant.available) {
            pill.style.display = 'none';
          }
        });
      }
    };
    xhr.send();
  });
}

// ===== KLAVIYO REVIEWS =====
function initKlaviyoReviews() {
  const reviewCount = document.querySelector('.kl_reviews__summary__stars__count');
  const summaryWrapper = document.querySelector('#klaviyo-reviews-summary');
  const reviewTab = document.querySelector('#kl_reviews_tabs__reviews_tab small');
  const reviewsList = document.querySelector('.kl_reviews__reviews_list');

  if (!reviewCount || !summaryWrapper || !reviewTab || !reviewsList) return false;

  const count = parseInt(reviewCount.textContent);
  if (count === 0 || isNaN(count)) {
    summaryWrapper.classList.add('no-reviews');
  }

  const listCount = parseInt(reviewTab.textContent);
  if (listCount === 0) {
    reviewsList.classList.add('no-reviews-yet');
  }

  if (window.innerWidth <= 749 && !document.querySelector('.kl-reviews-toggle')) {
    reviewsList.style.display = 'none';

    const toggle = document.createElement('button');
    toggle.textContent = 'See all reviews ↓';
    toggle.className = 'kl-reviews-toggle';
    toggle.style.cssText = `
      display: block;
      width: 100%;
      padding: 10px 0;
      margin-top: 8px;
      background: none;
      border: none;
      border-top: 1px solid rgba(0,0,0,0.1);
      font-size: 11px;
      letter-spacing: 0.15em;
      text-transform: capitalize;
      cursor: pointer;
      color: #000;
      text-align: center;
    `;

    toggle.addEventListener('click', function() {
      const isOpen = reviewsList.style.display !== 'none';
      reviewsList.style.display = isOpen ? 'none' : 'block';
      toggle.textContent = isOpen ? 'See all reviews ↓' : 'Hide reviews ↑';
    });

    summaryWrapper.appendChild(toggle);
  }

  return true;
}

// ===== MOBILE: MOVE WRITE A REVIEW BUTTON =====
function initMoveWriteReviewBtn() {
  if (window.innerWidth >= 750) return true;

  const reviewsList = document.getElementById('klaviyo-reviews-list');
  if (!reviewsList) return false;

  const searchRoot = document.getElementById('klaviyo-product-reviews-wrapper') || document.body;
  const btn = searchRoot.querySelector('[class*="write_review"]') ||
              searchRoot.querySelector('[class*="write-review"]') ||
              Array.from(searchRoot.querySelectorAll('button, a')).find(el =>
                el.textContent.trim().toLowerCase().includes('write')
              );

  if (!btn) return false;

  btn.style.setProperty('display', 'block', 'important');
  btn.style.setProperty('margin-top', '24px', 'important');
  reviewsList.after(btn);
  return true;
}

// ===== MAIN =====
document.addEventListener('DOMContentLoaded', function() {
  hideUnavailableVariants();

  let klaviyoDone = false;
  let writeBtnDone = false;
  let variantThrottle = null;

  const observer = new MutationObserver(function() {
    if (!klaviyoDone) klaviyoDone = initKlaviyoReviews();
    if (!writeBtnDone) writeBtnDone = initMoveWriteReviewBtn();

    clearTimeout(variantThrottle);
    variantThrottle = setTimeout(hideUnavailableVariants, 500);

    if (klaviyoDone && writeBtnDone) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 15000);

  // Variant pill click
  document.addEventListener('click', function(e) {
    const span = e.target.closest('.variant-pill');
    if (!span || !span.dataset.variantId) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = span.dataset.variantId;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');

    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        console.log('✅ Added to cart');

        const xhrDrawer = new XMLHttpRequest();
        xhrDrawer.open('GET', '/?sections=cart-drawer,cart-icon-bubble', true);

        xhrDrawer.onload = function() {
          if (xhrDrawer.status >= 200 && xhrDrawer.status < 300) {
            const sections = JSON.parse(xhrDrawer.responseText);
            const parser = new DOMParser();

            if (sections['cart-drawer']) {
              const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
              const newCartDrawerDiv = doc.querySelector('#CartDrawer');
              const oldCartDrawerDiv = document.querySelector('#CartDrawer');
              if (newCartDrawerDiv && oldCartDrawerDiv) {
                oldCartDrawerDiv.innerHTML = newCartDrawerDiv.innerHTML;
                const cartDrawer = document.querySelector('cart-drawer');
                const overlay = oldCartDrawerDiv.querySelector('#CartDrawer-Overlay');
                if (cartDrawer && overlay) {
                  overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
                }
              }

              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.classList.remove('is-empty');
            }

            if (sections['cart-icon-bubble']) {
              const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
              const newBubble = doc.querySelector('.cart-count-bubble');
              const oldBubble = document.querySelector('.cart-count-bubble');
              if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
            }

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              const cartIcon = document.querySelector('.header__icon--cart') ||
                               document.querySelector('a[href="/cart"]') ||
                               document.querySelector('#cart-icon-bubble');
              if (cartIcon) cartIcon.click();
            }
          }
        };
        xhrDrawer.send();

      } else {
        const response = JSON.parse(xhr.responseText);
        if (response.description && response.description.includes('sold out')) {
          span.textContent = 'Sold Out';
          span.style.pointerEvents = 'none';
          span.style.opacity = '0.5';
        } else {
          console.error('❌ Error adding to cart:', response);
        }
      }
    };

    xhr.onerror = function() { console.error('❌ Network error'); };
    xhr.send(JSON.stringify({ id: variantId, quantity: 1 }));
  });

  // Keyboard accessibility
  document.addEventListener('keydown', function(e) {
    const span = e.target.closest('.variant-pill');
    if (span && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      span.click();
    }
  });
});